import React, { useEffect, useState } from "react";
import commonStyles from "../../style/common.module.css";
import { getStudentAssignments } from "../service/assignment-service";
import { ModuleAssignment } from "../model/module-assignment";
import { BadgeAssignment } from "../model/badge-assignment";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, LinearProgress, Tab } from "@mui/material";
import { useAuth } from "../../../context/auth/auth-provider";
import StudentSubmit from "./-student-submit/student-submit";
import StudentJournal from "./-student-journal/student-journal";
import StudentCalendar from "./-student-calendar/student-calendar";
import { useSearchParams } from "react-router-dom";
import { ASSIGNMENT_QUERY_PARAMETER_TAB, ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_GROUP, ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_CALENDAR, ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_JOURNAL, ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_STUDENT_SUBMIT } from "../utils/assignment-constants";
import { getBadgeTerminology, getGeneralCourseLevel } from "../utils/terminology";
import StudentGroupDashboard from "./student-group-dashboard";
import { getUnsubmittedBadges } from "./utils/student-assignment-tools";
import { Role } from "../../enum/role";

export default function StudentHome() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState<string>(searchParams.get(ASSIGNMENT_QUERY_PARAMETER_TAB) ?? ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_STUDENT_SUBMIT);
    const [loading, setLoading] = useState(true);
    const [moduleAssignments, setModuleAssignments] = useState<ModuleAssignment[]>([]);

    const auth = useAuth();

    const generalCourseLevel = getGeneralCourseLevel(moduleAssignments);
    const isLoropioGirl = auth.user?.roles.includes(Role.LoropioGirlsExplorer) ?? false;

    useEffect(() => {
        setLoading(true);
        getStudentAssignments().then((result) => {
            result.forEach(_ => _.badges.forEach(b => b.moduleId = _.moduleId));
            setModuleAssignments(result);
            setLoading(false)
        }).catch(() => {
            setLoading(false);
        });
    }, []);

    const updateModuleAssignments = (badgeAssignment: BadgeAssignment) => {
        var updateModuleAssignments = [...moduleAssignments!];
        var module = updateModuleAssignments.find(_ => _.badges.filter(b => b.badgeId === badgeAssignment.badgeId).length > 0);
        var badge = module?.badges.find(_ => _.badgeId === badgeAssignment.badgeId);

        if (module !== undefined && badge !== undefined) {
            let bargeIndex = module.badges.indexOf(badge);
            let moduleIndex = updateModuleAssignments.indexOf(module);

            module.badges[bargeIndex] = badgeAssignment;
            module.badges.sort((a, b) => {
                return (a.sequence ?? 0) - (b.sequence ?? 0)
            });

            updateModuleAssignments[moduleIndex] = module;
            
            setModuleAssignments(updateModuleAssignments);
        }
    }

    return (
        <React.Fragment>
            <div className={commonStyles.content}>
                <h3>Welcome {auth.user?.name}!</h3>
                <span>
                    Happy to see you :) Are you ready to <b>Submit</b> some&nbsp;
                    {getBadgeTerminology(generalCourseLevel, true)}?
                </span>
            </div>
            {loading === true && <LinearProgress />}
            {loading === false && <TabContext value={tab} >
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={(_event: React.SyntheticEvent, newTab: string) => {
                        setTab(newTab);
                        setSearchParams({ [ASSIGNMENT_QUERY_PARAMETER_TAB]: newTab });
                    }}>
                        <Tab label="Submit" value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_STUDENT_SUBMIT} />
                        <Tab label="Journal" value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_JOURNAL} />
                        {isLoropioGirl && <Tab label="My Group" value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_GROUP} />}
                        {auth.user?.cohortId && <Tab label="Calendar" value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_CALENDAR} />}
                    </TabList>
                </Box>
                <TabPanel value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_STUDENT_SUBMIT} >
                    <StudentSubmit
                        generalCourseLevel={generalCourseLevel}
                        unsubmittedModuleAssignments={moduleAssignments.filter(_ => getUnsubmittedBadges(_).length >= 1)}
                        updateModuleAssignments={updateModuleAssignments}
                        enableDismiss={false}
                    />
                </TabPanel>
                <TabPanel value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_JOURNAL} >
                    <StudentJournal
                        generalCourseLevel={generalCourseLevel}
                        submittedModuleAssignments={moduleAssignments.filter(_ => _.badges.filter(b => b.submissionDate !== undefined).length >= 1)}
                        updateModuleAssignments={updateModuleAssignments}
                    />
                </TabPanel>
                <TabPanel value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_GROUP}>
                    {isLoropioGirl && <StudentGroupDashboard />}
                </TabPanel>
                {auth.user?.cohortId && (
                    <TabPanel value={ASSIGNMENT_QUERY_PARAMETER_TAB_VALUE_CALENDAR}>
                        <StudentCalendar cohortId={auth.user.cohortId} />
                    </TabPanel>
                )}
            </TabContext>}
        </React.Fragment>
    );
}
